//Dependencies
import * as uploadService from "../../Service/FileUploadService";
import { toasterModel, toasterColor } from "../../Models/ToasterModel";

export default {
  name: "ImportPayroll",

  data: () => ({
    isLoading: false,
    imageName: "",
  }),

  methods: {
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },

    pickFile() {
      this.$refs.image.click();
    },

    async upload() {
      if (this.imageName == "") {
        this.snackbar.isActive = true;
        this.snackbar.text = "Please select an excel";
        this.snackbar.color = "warning";
        return false;
      }
      let formData = new FormData();
      formData.append("file", this.imageFile);
      this.isLoading = true;
      let result = await uploadService.UploadPayrollExemptionDetailsExcel(
        formData
      );
      console.log(result);
      if (!result.error) {
        let msg = result.data + " successfully";
        // showToaster(msg, toasterColor.Success);
        this.$store.commit("toaster", toasterModel(msg, toasterColor.success));
        this.imageName = "";
        this.$refs.image.value = "";
      } else {
        let msg = result.data
          ? result.data.data
            ? result.data.data.Message
            : "Excel Upload Failed"
          : "Excel Upload Failed";
        console.log(msg);
        // showToaster(msg, toasterColor.Warning);
        this.$store.commit("toaster", toasterModel(msg, toasterColor.error));

        this.imageName = "";
        this.$refs.image.value = "";
      }
      this.isLoading = false;
    },
  },
};
